import { IDashboardGroup } from '@/pages/Dashboards/dashboards.types.ts'
import useDashboardGroups from '@/pages/Dashboards/hooks/useDashboardGroups.ts'
import { useMemo } from 'react'

const useDashboardGroup = (id: IDashboardGroup['id']) => {
  const groups = useDashboardGroups().groups

  return useMemo(() => {
    return groups.find((g) => g.id === id)
  }, [id, groups])
}

export default useDashboardGroup
